/**
 * Document validators - Document and file related types
 */
import { Infer, v } from 'convex/values';

// ============================================================================
// Document Type
// ============================================================================

export const documentTypeValidator = v.union(
  v.literal('image'),
  v.literal('schein'),
  v.literal('other')
);

export type DocumentType = Infer<typeof documentTypeValidator>;

export const DOCUMENT_TYPES = ['image', 'schein', 'other'] as const;

// ============================================================================
// Document Status
// ============================================================================

export const documentStatusValidator = v.union(
  v.literal('submitted'),
  v.literal('approved'),
  v.literal('rejected')
);

export type DocumentStatus = Infer<typeof documentStatusValidator>;

export const DOCUMENT_STATUSES = ['submitted', 'approved', 'rejected'] as const;

// ============================================================================
// Service Document Source
// ============================================================================

export const serviceDocumentSourceValidator = v.union(
  v.literal('chat'),
  v.literal('upload'),
  v.literal('import')
);

export type ServiceDocumentSource = Infer<typeof serviceDocumentSourceValidator>;

export const SERVICE_DOCUMENT_SOURCES = ['chat', 'upload', 'import'] as const;

// ============================================================================
// Other Document Verification Status
// ============================================================================

export const otherDocumentVerificationStatusValidator = v.union(
  v.literal('pending_review'),
  v.literal('approved'),
  v.literal('rejected'),
  v.literal('changes_requested')
);

export type OtherDocumentVerificationStatus = Infer<typeof otherDocumentVerificationStatusValidator>;

export const OTHER_DOCUMENT_VERIFICATION_STATUSES = [
  'pending_review',
  'approved',
  'rejected',
  'changes_requested',
] as const;
